<template>
    <el-dialog :visible.sync="visible" :title="$t('privateNetInstance.operations.makeMirror')" :close-on-click-modal="false"
        :before-close="handleClose">
        <!--实例信息-->
        <h3 class="title-position">
            {{ $t('privateNetInstance.instanceInfo') | withColon }}
        </h3>
        <el-table :data="[rowInfo]">
            <el-table-column :label="$t('privateNetInstance.instanceID')" key="instanceId" min-width="150px">
                <template slot-scope="scope">
                    {{ scope.row.instanceId }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('privateNetInstance.instanceName')" key="name" min-width="100px">
                <template slot-scope="scope">
                    {{ scope.row.name }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('list.specifications')" key="cpsConfiguration">
                <template slot-scope="scope">
                    {{ scope.row.cpsConfiguration && scope.row.cpsConfiguration.deviceType &&
                        scope.row.cpsConfiguration.deviceType.name | maybeEmpty }}
                </template>
            </el-table-column>
            <!--实例配置-->
            <el-table-column key="config" min-width="130" :label="$t('privateNetInstance.instanceConfig')">
                <template slot-scope="scope">
                    <p>{{ scope.row.cpsConfiguration.cpu }}</p>
                    <p>{{ scope.row.cpsConfiguration.mem }}</p>
                    <p>{{ scope.row.systemDiskDesc }}</p>
                </template>
            </el-table-column>
            <el-table-column :label="$t('privateNetInstance.mirrorInfo')" key="system" min-width="150px">
                <template slot-scope="scope">
                    <p>{{ $t('mirror.text.architecture') + ': ' + scope.row.architecture }}</p>
                    <p>{{ $t('mirror.text.osType') + ': ' + scope.row.osType }}</p>
                    <p>{{ $t('mirror.text.systemVersion') + ': ' + scope.row.systemVersion }}</p>
                </template>
            </el-table-column>
        </el-table>
        <el-form :model="ruleForm" ref="form" :rules="rules" label-width="100px" :label-position="labelPosition"
            class="mirror-form">
            <!--镜像名称-->
            <el-form-item :label="$t('mirror.text.mirrorName') | withColon" prop="mirrorName" :show-message="false"
                ref="mirrorName" required>
                <el-input v-model="ruleForm.mirrorName" class="name" @blur="ruleFormTag.mirrorName = 1"
                    @focus="ruleFormTag.mirrorName = 0"></el-input>
                <p v-if="ruleFormTag.mirrorName !== 0 && ruleForm.mirrorName == ''" class="el-form-item-help-error">
                    {{ $t('create.placeholder.nameNull') }}</p>
                <p v-else class="el-form-item-help"
                    :class="{ 'el-form-item-help-error': this.ruleFormTag.mirrorName == 'error' }">
                    {{ $t('create.help.name') }}</p>
            </el-form-item>
            <!--描述-->
            <el-form-item :label="$t('create.text.desc') | withColon" prop="mirrorDesc" :show-message="false"
                ref="mirrorDesc">
                <el-input type="textarea" :rows="4" class="w500" v-model="ruleForm.mirrorDesc" placeholder=""></el-input>
                <p class="el-form-item-help" :class="{ 'el-form-item-help-error': this.ruleFormTag.mirrorDesc == 'error' }">
                    {{ $t('create.help.desc') }}</p>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-resystem-footer">
            <el-button @click="cancel">{{ $t('privateNetwork.cancel') }}</el-button>
            <el-button @click="sure" type="primary">{{ $t('privateNetwork.sure') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { createImageApi } from '@/api/privateInstance/list/actions'
import { validateName } from '@/common/dataHelper';

export default {
    name: 'MakeMirror',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rowInfo: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        const valName = (rule, value, callback) => {
            if (!validateName(value)) {
                callback(new Error());
            } else {
                callback();
            }
        };
        return {
            rules: {
                mirrorName: [
                    {
                        type: 'string',
                        validator: valName,
                        trigger: 'blur'
                    }
                ],
                mirrorDesc: [
                    { type: 'string', pattern: new RegExp('^.{0,256}$'), trigger: 'blur' }
                ],
            },
            ruleFormTag: {
                mirrorName: 0,
                mirrorDesc: 0,
            },
            ruleForm: {
                mirrorName: '',
                mirrorDesc: '',
            },
            labelPosition: "left"
        };
    },
    computed: {

    },
    watch: {
    },
    created() {
    },
    methods: {

        handleClose() {
            this.$emit('update:visible', false);
        },

        cancel() {
            this.handleClose();
        },

        sure() {
            let formValid;
            this.$refs.form.validate((valid) => {
                formValid = valid;
            });

            if (!formValid) {
                this.ruleFormTag.mirrorName = this.$refs.mirrorName.validateState;
                this.ruleFormTag.mirrorDesc = this.$refs.mirrorDesc.validateState;
                return false;
            }
            let params = {
                imageName: this.ruleForm.mirrorName,
                instanceId: this.rowInfo.instanceId,
                remark: this.ruleForm.mirrorDesc,
                region: this.rowInfo.region
            };
            createImageApi(params).then(res => {
                if (res.data.success) {
                    this.$message.success(this.$t('privateNetInstance.operateSuccess'));
                    this.$emit('refresh');
                }
            }).catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
                .finally(() => {
                    this.$emit('update:visible', false);
                });
        },


    }
};
</script>

<style lang="scss" scoped>
.mirror-form {
    margin: 20px 0 0;

    .name {
        width: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/makeMirror/Index.vue